import validate from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_e7266ef62fd2a8e98ff8b66fd507900a/node_modules/nuxt/dist/pages/runtime/validate.js";
import clear_45language_45switcher_45links_45global from "/usr/src/app/src/middleware/clearLanguageSwitcherLinks.global.ts";
import manifest_45route_45rule from "/usr/src/app/node_modules/.pnpm/nuxt@4.6.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_e7266ef62fd2a8e98ff8b66fd507900a/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  clear_45language_45switcher_45links_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "get-layout": () => import("/usr/src/app/src/middleware/getLayout.ts"),
  "logged-in-redirect": () => import("/usr/src/app/src/middleware/loggedInRedirect.ts")
}